import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Images
import industry from "../assets/img/Industry-Knowledge.png";
import software from "../assets/img/software 101.jpeg";
import maintenance from "../assets/img/mantan.jpeg";
import patented from "../assets/img/patented.jpeg";
import security from "../assets/img/security.jpeg";
import customizable from "../assets/img/customized-solution.png";
import consulting from "../assets/img/consulting.jpeg";
import scalable from "../assets/img/scalable.jpeg";
import training from "../assets/img/traning.jpeg";
import time from "../assets/img/12-2-time-png-clipart.png";

const featuresData = [
  {
    title: "Well-Established Industry Knowledge",
    desc: "Years of experience across diverse sectors, enabling tailored solutions that meet specific business needs.",
    img: industry,
  },
  {
    title: "Exceptional ICT & Software Development Experience",
    desc: "Specialized in delivering robust, reliable, and scalable software solutions using the latest technologies.",
    img: software,
  },
  {
    title: "Strong Maintenance and Follow-Up",
    desc: "Comprehensive post-implementation support and proactive monitoring to ensure seamless operations.",
    img: maintenance,
  },
  {
    title: "Patented + Licensed",
    desc: "Proprietary and licensed technologies to ensure innovative, compliant, and reliable solutions.",
    img: patented,
  },
  {
    title: "Highly Secured",
    desc: "State-of-the-art security measures to protect your business from potential threats and vulnerabilities.",
    img: security,
  },
  {
    title: "Customizable",
    desc: "Flexible and adaptable solutions tailored to meet unique requirements and preferences.",
    img: customizable,
  },
  {
    title: "Wholistic Consultation",
    desc: "End-to-end guidance, from strategic planning to operational execution, ensuring sustainable success.",
    img: consulting,
  },
  {
    title: "Scalable",
    desc: "Solutions that grow with your business, ensuring longevity and relevance in a dynamic market.",
    img: scalable,
  },
  {
    title: "Transformative Training",
    desc: "Comprehensive training programs to empower your workforce with the skills they need to excel.",
    img: training,
  },
  {
    title: "Shorter Lead Time",
    desc: "Efficient processes and workflows that ensure faster delivery without compromising on quality.",
    img: time,
  },
];

const Features = () => {
  return (
    <div className="container-fluid features overflow-hidden py-5" id="features">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-5" data-aos="fade-up" data-aos-delay="100">
          <div className="sub-style">
            <h5 className="sub-title" style={{ color: "#A71717" }}>Why Choose Us</h5>
          </div>
          <h1 className="display-5 mb-4" style={{ color: "#A71717" }}>
            Empowering Businesses Through Innovation
          </h1>
          <p className="mb-0" style={{ color: "#666" }}>
            We combine industry expertise with cutting-edge technology to deliver comprehensive business solutions that drive growth and efficiency.
          </p>
        </div>

        {/* Swiper Carousel */}
        <Swiper
          modules={[Navigation, Pagination, A11y]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
          }}
        >
          {featuresData.map((item, i) => (
            <SwiperSlide key={i}>
              <div className="card h-100 shadow-sm text-center border-0">
                <img
                  src={item.img}
                  alt={item.title}
                  className="card-img-top p-2"
                  style={{ height: "200px", objectFit: "contain" }}
                />
                <div className="card-body">
                  <h5 className="fw-bold" style={{ color: "#A71717" }}>
                    {item.title}
                  </h5>
                  <p className="text-muted">{item.desc}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Features;
